module.exports = __webpack_public_path__ + "static/media/group_30.05097e1a.jpg";